<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouterLink } from 'vue-router';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

defineProps({
  brandVoiceRoute: { type: [String, Object], required: true },
});

const { t } = useI18n();

const brandVoiceSummaryItems = computed(() => [
  {
    icon: 'i-lucide-user-round',
    title: t('BRAND_VOICE.MY_LAIS_SUMMARY.ITEMS.PERSONA_TONE.TITLE'),
    helper: t('BRAND_VOICE.MY_LAIS_SUMMARY.ITEMS.PERSONA_TONE.HELPER'),
  },
  {
    icon: 'i-lucide-message-circle-heart',
    title: t('BRAND_VOICE.MY_LAIS_SUMMARY.ITEMS.GREETING_SIGNATURE.TITLE'),
    helper: t('BRAND_VOICE.MY_LAIS_SUMMARY.ITEMS.GREETING_SIGNATURE.HELPER'),
  },
  {
    icon: 'i-lucide-list-checks',
    title: t('BRAND_VOICE.MY_LAIS_SUMMARY.ITEMS.EXAMPLES_RULES.TITLE'),
    helper: t('BRAND_VOICE.MY_LAIS_SUMMARY.ITEMS.EXAMPLES_RULES.HELPER'),
  },
  {
    icon: 'i-lucide-book-open-text',
    title: t('BRAND_VOICE.MY_LAIS_SUMMARY.ITEMS.STRUCTURED_GUIDE.TITLE'),
    helper: t('BRAND_VOICE.MY_LAIS_SUMMARY.ITEMS.STRUCTURED_GUIDE.HELPER'),
  },
]);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard :title="t('BRAND_VOICE.MY_LAIS_SUMMARY.CARD_TITLE')">
    <div
      class="overflow-hidden rounded-lais border border-[#e4d7f0] bg-gradient-to-br from-[#faf8fd] via-white to-[#f7f4fb]"
    >
      <div
        class="flex flex-col gap-5 p-5 sm:p-6 lg:flex-row lg:items-center lg:justify-between"
      >
        <div class="min-w-0 max-w-3xl">
          <span
            class="inline-flex items-center gap-1.5 rounded-full border border-[#d9c6eb] bg-white px-2.5 py-1 text-[11px] font-semibold text-lais-primary"
          >
            <span class="i-lucide-badge-check size-3.5" aria-hidden="true" />
            {{ t('BRAND_VOICE.MY_LAIS_SUMMARY.STATUS') }}
          </span>
          <h3 class="mt-3 text-[17px] font-semibold text-lais-text">
            {{ t('BRAND_VOICE.MY_LAIS_SUMMARY.TITLE') }}
          </h3>
          <p
            class="mt-1.5 max-w-2xl text-[13px] leading-6 text-lais-text-muted"
          >
            {{ t('BRAND_VOICE.MY_LAIS_SUMMARY.DESCRIPTION') }}
          </p>
        </div>

        <RouterLink
          :to="brandVoiceRoute"
          class="inline-flex min-h-11 w-full shrink-0 items-center justify-center gap-2 rounded-lais bg-lais-primary px-4 py-2.5 text-center text-[13px] font-semibold text-white transition-colors hover:bg-[#3a2762] focus:outline-none focus:ring-2 focus:ring-lais-primary/30 sm:w-fit"
        >
          <span class="i-lucide-arrow-up-right size-4" aria-hidden="true" />
          {{ t('BRAND_VOICE.MY_LAIS_SUMMARY.CTA') }}
        </RouterLink>
      </div>

      <div class="grid border-t border-[#e8e0ef] sm:grid-cols-2 xl:grid-cols-4">
        <article
          v-for="item in brandVoiceSummaryItems"
          :key="item.title"
          class="flex gap-3 border-b border-[#eee8f3] p-4 last:border-b-0 sm:[&:nth-last-child(-n+2)]:border-b-0 sm:[&:nth-child(odd)]:border-r xl:border-b-0 xl:border-r xl:last:border-r-0"
        >
          <span
            class="flex size-9 shrink-0 items-center justify-center rounded-lais-sm bg-[#f0e8fa] text-lais-primary"
            aria-hidden="true"
          >
            <span class="size-4" :class="item.icon" />
          </span>
          <span class="min-w-0">
            <strong class="block text-[13px] font-semibold text-lais-text">
              {{ item.title }}
            </strong>
            <span
              class="mt-0.5 block text-[12px] leading-5 text-lais-text-muted"
            >
              {{ item.helper }}
            </span>
          </span>
        </article>
      </div>
    </div>
  </LaisCard>
</template>
